import { render, staticRenderFns } from "./PartnerCommission.vue?vue&type=template&id=58f58ff3&"
import script from "./PartnerCommission.vue?vue&type=script&lang=js&"
export * from "./PartnerCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58f58ff3')) {
      api.createRecord('58f58ff3', component.options)
    } else {
      api.reload('58f58ff3', component.options)
    }
    module.hot.accept("./PartnerCommission.vue?vue&type=template&id=58f58ff3&", function () {
      api.rerender('58f58ff3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/PartnerCommission.vue"
export default component.exports